import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GridApi } from 'ag-grid-community';
import { IstSummaryService } from 'src/app/services/ist/ist-summary.service';
import { IstMilestonesViewModalComponent } from './ist-milestones-view-modal/ist-milestones-view-modal.component';
import { DeleteBoxComponent } from 'src/app/common/delete-box/delete-box.component';
import { IstDataShareService } from '../../../services/ist/ist-datashare.service';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { CommonService } from '../../../services/common.service';
import { UserService } from '../../../services/user.service';
import { DatePipe } from '@angular/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DateObject } from 'src/app/models/common';
@Component({
  selector: 'app-ist-milestones',
  templateUrl: './ist-milestones.component.html',
  styleUrls: ['./ist-milestones.component.scss']
})
export class IstMilestonesComponent implements OnInit {

  columnDefs;
  tempoperations;
  operations;
  gridApi: GridApi;
  selectedRow;
  rowData;
  staticformFields: any;
  ApplicationID: string;
  milestonesform: UntypedFormGroup;
  permission: string = "";
  userType: string = "";
  StartDateO: DateObject
  EndDateO: DateObject;
  collapesedOrNot:boolean=false;
  screenName: string = "";

  constructor(
    public route: ActivatedRoute,
    private summaryService: IstSummaryService,
    private modalService: NgbModal,
    private datashareService: IstDataShareService,
    private commonService: CommonService,
    private userService: UserService,
    private datepipe: DatePipe
  ) {
  } 

  ngOnInit() {

    this.datashareService.ApplicationID.subscribe(x => {
      this.ApplicationID = x;
      this.GetScreenConfigControls('SCR-008');
    });
    this.milestonesform = new UntypedFormGroup({
      MileStone: new UntypedFormControl(""),
      Title: new UntypedFormControl(""),
      StartDate: new UntypedFormControl(null),
      EndDate: new UntypedFormControl(null),
      StartDateO: new UntypedFormControl(null),
      EndDateO: new UntypedFormControl(null)
    });

    this.permission = this.commonService.getPagePermission("IST08").toLowerCase();

    if (this.permission == null || this.permission == undefined || this.permission == '') {
      const intervalId = setInterval(() => {
        this.permission = this.commonService.getPagePermission("IST08").toLowerCase();
        if (this.permission != null && this.permission != undefined && this.permission != '') {
          this.setSummary();
          clearInterval(intervalId);
        }
      }, 1000);
    }
    else {
      this.setSummary();
    }

    this.getStaticFiledsData('SCR-008');
    this.userType = this.userService.getUserType();
    // this.datashareService.ApplicationID.subscribe(x => {
    //   this.ApplicationID = x;
    // });
    this.tempoperations = [];
    this.operations = this.tempoperations.map(operation => {
      return (operation && (operation.id === 'add' || operation.id === 'view_modal')) ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
    });
  }

  getStaticFiledsData(screenCode: string) {
    this.commonService.getScreenStaticFields(screenCode, this.ApplicationID)
      .subscribe(summary => {
        this.staticformFields = summary["Data"];
        if(this.userType == "E"){
          this.columnDefs = [
            {
              "headerName": this.staticformFields?.MILESTONE_NO.LABEL_NAME,
              "field": "MileStone"
            },
            {
              "headerName": this.staticformFields?.TITLE.LABEL_NAME,
              "field": "Title"
            },
            {
              "headerName": this.staticformFields?.STUDY_START_DATE.LABEL_NAME,
              "field": "StartDateStr"
            },
            {
              "headerName": this.staticformFields?.STUDY_END_DATE.LABEL_NAME,
              "field": "EndDateStr"
            },
            {
              "headerName": "Submitted Date",
              "field": "SubmittedDateStr"
            },
            {
              "headerName": "Status",
              "field": "Status"
            }
          ];
        } else{
          this.columnDefs = [
            {
              "headerName": this.staticformFields?.MILESTONE_NO.LABEL_NAME,
              "field": "MileStone"
            },
            {
              "headerName": this.staticformFields?.TITLE.LABEL_NAME,
              "field": "Title"
            },
            {
              "headerName": this.staticformFields?.STUDY_START_DATE.LABEL_NAME,
              "field": "StartDateStr"
            },
            {
              "headerName": this.staticformFields?.STUDY_END_DATE.LABEL_NAME,
              "field": "EndDateStr"
            },
            {
              "headerName": "Submitted Date",
              "field": "SubmittedDateStr"
            }
          ];
        }
      });
      
  }

  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  } 

  onCallbackOperation(opr) {
    opr.callback();
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  onRowDoubleClicked(event) {
    
    const modelRef=this['self'].modalService.open(IstMilestonesViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-llg right modal-right',
      animation: true
    });
    modelRef.componentInstance.Content={
      heading: 'View',
      content: { id: event.data['ID'], ApplicationID: this.ApplicationID }
    }
  }

  add() {
    
    let modalRef = this.modalService.open(IstMilestonesViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-llg right modal-right',
      animation: true
    });
      modalRef.componentInstance.Content={
      heading: 'Add',
      content: { id: "", ApplicationID: this.ApplicationID }
    }
    modalRef.result.then(result => {
      this.setSummary();
    })
  }

  edit( Record: any) {
    let modalRef = this['self'].modalService.open(IstMilestonesViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-llg right modal-right',
      animation: true,
    });
      modalRef.componentInstance.Content={
        heading: "Edit",
        content: { id: Record['ID'], ApplicationID: this.ApplicationID }
      }
   
    modalRef.result.then(result => {
      this['self'].setSummary();
    })
  }

  view( Record: any) {
    let modalRef = this['self'].modalService.open(IstMilestonesViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-llg right modal-right',
      animation: true,
    });
    modalRef.componentInstance.Content={
        heading: "View",
        content: { id: Record['ID'], ApplicationID: this.ApplicationID }
      }
    
    modalRef.result.then(result => {
      this['self'].setSummary();
    })
  }

  delete() {
    if (this['self'].selectedRow['SubmittedDateStr'] == null || this['self'].selectedRow['SubmittedDateStr'] == undefined || this['self'].selectedRow['SubmittedDateStr'] == "") {
      let id = this['self'].selectedRow['ID'];
      let title = this['self'].selectedRow['Title']; 
      const modalRef = this["self"].modalService.open(DeleteBoxComponent, {backdrop: false});
        modalRef.componentInstance.Content= { heading: 'Delete Milestone', custommessage: 'Are you sure you want to delete '  + ' ?', ProceedButtonName: "Delete", TerminateButtonName: "Cancel" };

        modalRef.result.then(result => {
        if (result == "okclick") {
          this['self'].summaryService.DeleteRecord('api/ISTMilestones/Delete?RecordID=' + id).subscribe(summary => {
            if (summary["Status"] == 0) {                           
              this["self"].commonService.SuccessBanner(this['self'].screenName +' deleted successfully');
              this['self'].setSummary();
            }
            else {
              this["self"].commonService.ValidationBanner("Selected Record(s) has not been Deleted");

            }
          });
        }
      });
    }
    else {
      this.commonService.ValidationBanner("Record Can't be Deleted");
    }   
  }

  setSummary() {
    this.SearchClear();
    this.summaryService.getSummaryData("api/ISTMilestones/getSummaryData?ApplicationID=" + this.ApplicationID).subscribe(summary => {
      this.rowData = this.setOperations(summary);
    });
  }

  getSearchSummary(searchObject) {
    this.summaryService.fetchSearchData("api/ISTMilestones/getSummarySearchData", searchObject).subscribe(summary => {
      this.rowData = this.setOperations(summary);
    });
  }

  SearchClear() {
    this.milestonesform.controls["MileStone"].setValue("");
    this.milestonesform.controls["Title"].setValue("");
    this.milestonesform.controls["StartDate"].setValue(null);
    this.milestonesform.controls["EndDate"].setValue(null);
  } 
  
  isStartDateModified: boolean = false;
  isEndDateModified: boolean = false;
  Full_Start_Date: DateObject;
  Full_End_Date: DateObject;

  startDateSelect(event) {
    this.isStartDateModified = true
    this.Full_Start_Date = {
      Day: event.getDate(),
      Month: (event.getMonth() + 1),
      Year: event.getFullYear(),
      Hours: 0,
      Minutes: 0,
      Seconds: 0,
      IsEndDate: false,
      HasValue: true,
      IsDateModified: this.isStartDateModified
    }
  }
  endDateSelect(event) {
    this.isEndDateModified = true;
    this.Full_End_Date = {
      Day: event.getDate(),
      Month: (event.getMonth() + 1),
      Year: event.getFullYear(),
      Hours: 23,
      Minutes: 59,
      Seconds: 59,
      IsEndDate: true,
      HasValue: true,
      IsDateModified: this.isEndDateModified
    }
  }

  AdvanceSearch() {
    var formData = this.milestonesform.value;
    if(!this.validateSearch()){
      
      formData["ApplicationID"] = this.ApplicationID;
      if (formData["StartDate"] != null && formData["StartDate"] != undefined && formData["StartDate"] != 'Invalid Date') {
        formData["StartDate"] = new Date(formData["StartDate"]);
        formData["StartDateO"] = this.Full_Start_Date;
      }
      if (formData["EndDate"] != null && formData["EndDate"] != undefined && formData["EndDate"] != 'Invalid Date') {
        formData["EndDate"] = new Date(formData["EndDate"]);
        formData["EndDateO"] = this.Full_End_Date;
      }
      if (formData["StartDate"] != null && formData["StartDate"] != "" && formData["StartDate"] != undefined && formData["StartDate"] != 'Invalid Date') {
        formData["StartDateStr"] = this.datepipe.transform(formData["StartDate"], 'dd-MMM-yyyy');
      }
      if (formData["EndDate"] != null && formData["EndDate"] != "" && formData["EndDate"] != undefined && formData["EndDate"] != 'Invalid Date') {
        formData["EndDateStr"] = this.datepipe.transform(formData["EndDate"], 'dd-MMM-yyyy');
      }
      formData["StartDate"] = null;
      formData["EndDate"] = null;
      this.getSearchSummary(formData);
    } else{
      this.commonService.ValidationBanner("Please enter at least one criteria to perform search");
    }   
  }

  validateSearch(){
    let hasValue : Boolean = true;
    if(this.milestonesform.controls["EndDate"].value != null && this.milestonesform.controls["EndDate"].value != undefined && this.milestonesform.controls["EndDate"].value != 'Invalid Date'){
      hasValue = false;
    }

    if (this.milestonesform.controls["StartDate"].value != null && this.milestonesform.controls["StartDate"].value != undefined && this.milestonesform.controls["StartDate"].value != 'Invalid Date') {
      hasValue = false;
    }

    if (this.milestonesform.controls["MileStone"].value != null && this.milestonesform.controls["MileStone"].value != undefined && this.milestonesform.controls["MileStone"].value != "") {
      hasValue = false;
    }

    if (this.milestonesform.controls["Title"].value != null && this.milestonesform.controls["Title"].value != undefined && this.milestonesform.controls["Title"].value != "") {
      hasValue = false;
    }
    return hasValue;
  }

  setOperations(RawData: any): any {

    this.tempoperations = [];
    if (this.permission == "new") {
      this.tempoperations = [
        {
          "name": "Edit",
          "id": "edit"
        },
        {
          "name": "Delete",
          "id": "delete"
        },
        {
          "name": "View",
          "id": "view"
        },
        {
          "name": "Add Milestone",
          "id": "add"
        }
      ];
    }

    if (this.permission == "edit") {
      this.tempoperations = [
        {
          "name": "Edit",
          "id": "edit"
        },
        {
          "name": "Delete",
          "id": "delete"
        },
        {
          "name": "View",
          "id": "view"
        }
      ];
    }    

    this.setDef(this.tempoperations);
    RawData.forEach(element => {
      if (element.Status == "Submitted") {
        let tempoperations2 = [
          {
            "name": "View",
            "id": "view"
          }
        ];
        if (this.permission == "new") {
          tempoperations2.push({
            "name": "Add Milestone",
            "id": "add"
          })
        }
        element["Operations"] = this.setDef(tempoperations2);
      }

      if (element.Status == "Drafted") {
        element["Operations"] = this.setDef(this.tempoperations);
      }

      if (this.permission == "view") {
        this.tempoperations = [          
          {
            "name": "View",
            "id": "view"
          }
        ];

        element["Operations"] = this.setDef(this.tempoperations);
      }    
    });

    setTimeout(()=>{
      this.gridApi.sizeColumnsToFit();
      },500);
    return RawData;
  }

  setDef(parmoperations: any): any {
    this.operations = parmoperations.map(operation => {
      return operation &&
        (operation.id === "add" || operation.id === "view_modal")
        ? {
          name: operation.name,
          callback: this[operation.id],
          self: this,
          disabled: "false"
        }
        : { name: operation.name, callback: this[operation.id], self: this };
    });
    return this.operations;
  }


  GetScreenConfigControls(screenCode: string) {
    this.commonService.GetScreenConfigControls(screenCode, this.ApplicationID, '', (ScreenData) => {
      this.screenName = ScreenData.NAME;
    });
  }
}
